import { Item } from '@/api';
import AuthCode from '@/components/ecommerce/AuthCode';
import ProductBadge from '@/components/ecommerce/product/ProductBadge';
import clsx from 'clsx';
import React from 'react';

type Props = {
    product: Item | undefined;
    isEverythingLoaded: boolean;
    modal: boolean | undefined;
};

const PBCodeAndBadge = ({ product, isEverythingLoaded, modal }: Props) => {
    return (
        <div className={clsx('flex flex-row space-x-3 md:justify-start justify-center', { 'mb-6': !modal, 'mb-4': modal })}>
            <AuthCode trId={product?.tr_id || ''} type={product?.authentication_type} isLoading={!isEverythingLoaded} id="bid-top" itemType={product?.type} />
            {product && product.trending ? <ProductBadge theme="purple" type="trending" /> : null}
        </div>
    );
};

export default PBCodeAndBadge;
